/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencedEntityNullableLongDto } from './ReferencedEntityNullableLongDto';
import {
    ReferencedEntityNullableLongDtoFromJSON,
    ReferencedEntityNullableLongDtoFromJSONTyped,
    ReferencedEntityNullableLongDtoToJSON,
} from './ReferencedEntityNullableLongDto';

/**
 * 
 * @export
 * @interface CreateEnumerationValueListDto
 */
export interface CreateEnumerationValueListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationValueListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationValueListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {Array<ReferencedEntityNullableLongDto>}
     * @memberof CreateEnumerationValueListDto
     */
    selectedOptions?: Array<ReferencedEntityNullableLongDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationValueListDto
     */
    isUsedForEvaluation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationValueListDto
     */
    $type?: CreateEnumerationValueListDtoTypeEnum;
}


/**
 * @export
 */
export const CreateEnumerationValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateEnumerationValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateEnumerationValueListDtoTypeEnum = typeof CreateEnumerationValueListDtoTypeEnum[keyof typeof CreateEnumerationValueListDtoTypeEnum];


/**
 * Check if a given object implements the CreateEnumerationValueListDto interface.
 */
export function instanceOfCreateEnumerationValueListDto(value?: unknown): value is CreateEnumerationValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateEnumerationValueListDtoTypeEnum)[0];
}

export function CreateEnumerationValueListDtoFromJSON(json: any): CreateEnumerationValueListDto {
    return CreateEnumerationValueListDtoFromJSONTyped(json, false);
}

export function CreateEnumerationValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEnumerationValueListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'selectedOptions': !exists(json, 'selectedOptions') ? undefined : (json['selectedOptions'] === null ? null : (json['selectedOptions'] as Array<any>).map(ReferencedEntityNullableLongDtoFromJSON)),
        'isUsedForEvaluation': !exists(json, 'isUsedForEvaluation') ? undefined : json['isUsedForEvaluation'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateEnumerationValueListDtoToJSON(value?: CreateEnumerationValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'selectedOptions': value.selectedOptions === undefined ? undefined : (value.selectedOptions === null ? null : (value.selectedOptions as Array<any>).map(ReferencedEntityNullableLongDtoToJSON)),
        'isUsedForEvaluation': value.isUsedForEvaluation,
        '$type': value.$type,
    });
}

